import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Users, Eye } from 'lucide-react';

const PING_KEY = 'arthik_visitor_ping_day';

const VisitorCounter = () => {
  const [stats, setStats] = useState({ today: 0, total: 0 });

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const lastPing = localStorage.getItem(PING_KEY);
    const shouldPing = lastPing !== today;
    (async () => {
      try {
        if (shouldPing) {
          const r = await axios.post(`${API}/visitor/ping`);
          setStats({ today: r.data.today, total: r.data.total });
          localStorage.setItem(PING_KEY, today);
        } else {
          const r = await axios.get(`${API}/visitor/stats`);
          setStats({ today: r.data.today, total: r.data.total });
        }
      } catch {
        // silent — counter is decorative, never block UI
      }
    })();
  }, []);

  return (
    <div
      data-testid="visitor-counter"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 16,
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 999,
        padding: '8px 16px',
        fontSize: '0.78rem',
        color: '#CBD5E1',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <Eye size={14} style={{ color: '#FF6B35' }} />
        <strong style={{ color: 'white' }} data-testid="visitor-today">{Number(stats.today).toLocaleString('en-IN')}</strong>
        <span>today</span>
      </span>
      <span style={{ width: 1, height: 14, background: 'rgba(255,255,255,0.15)' }} />
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <Users size={14} style={{ color: '#10B981' }} />
        <strong style={{ color: 'white' }} data-testid="visitor-total">{Number(stats.total).toLocaleString('en-IN')}</strong>
        <span>total visits</span>
      </span>
    </div>
  );
};

export default VisitorCounter;
